module.exports = __webpack_public_path__ + "static/media/video-dots.adc56ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/video-dots.png
// module id = 753
// module chunks = 0